/*
* 组织架构动图组件
*/

import { useEffect, useState } from 'react';
import { OrganizationChart, CollapseExpandIcon } from '@ant-design/graphs';
import $ from 'jquery';
import CNF from '../../incs/Config.js';
import {
    Flex,
    Image,
} from 'antd';
import {
    UjoinParams,
    AddRequestHeaders,
} from '../../incs/FunHelper.js';

const { PlusMinusIcon } = CollapseExpandIcon;

const OrgStructureGraph = (props) => {
    const [data, setData] = useState({});

    /**
     * 获取列表
     */
    const getData = (orgInfoUlid) => {
        const params = {
            'rss': 'list',
            'org_info_ulid': orgInfoUlid,
            'status': CNF.status[0].value,
        };
        $.ajax({
            url: `${CNF.sealApi}org/structures${UjoinParams(params)}`,
            headers: AddRequestHeaders(),
            type: 'GET', success: function (data) {
                if (data.res === 0) {
                    let nodes = [];
                    let edges = [];
                    if (data.dat.length > 0) {
                        for (let i = 0; i < data.dat.length; i++) {
                            let item = data.dat[i];
                            nodes.push({
                                id: item.sid,
                                data: item,
                            });
                            if (item.up_sid) {
                                edges.push({
                                    source: item.up_sid,
                                    target: item.sid,
                                })
                            }
                        }
                        setData({
                            "nodes": nodes,
                            "edges": edges,
                        });
                    }
                }
            }
        })
    }

    useEffect(() => {
        if (props.orgInfosLists.length > 0) {
            getData(props.orgInfosLists[0].key);
        }
    }, [props]);

    const options = {
        autoFit: 'view',
        data,
        padding: [20, 0, 20, 0],
        node: {
            style: {
                component: (d) => {
                    const { title, name, level, icon_uri } = d.data || {};
                    var backgroundColor = CNF.swatches[CNF.currentSwatche];
                    if (level > 0) backgroundColor = CNF.swatches[CNF.currentSwatche][level - 1];
                    // const isActive = d.states?.includes('active');
                    return <div style={{
                        backgroundColor: backgroundColor,
                        borderRadius: 4,
                        width: 130,
                        height: 44,
                        color: '#fff',
                        textAlign: 'center',
                    }}><Flex>
                            {
                                icon_uri ? <Image src={CNF.ossApi + icon_uri} preview={false} width={34} height={34} style={{ marginTop: 5, marginLeft: 5 }} /> : ''
                            }
                            <div style={{
                                width: icon_uri ? 130 - 34 : 130,
                                height: 44,
                                display: 'flex',
                                justifyContent: 'center', /* 水平居中 */
                                alignItems: 'center',     /* 垂直居中 */
                            }}>
                                {title}
                                {
                                    name ? <><br />{name}</> : ''
                                }
                            </div>
                        </Flex>
                    </div>
                },
                size: [130, 44],
            },
        },
        edge: {
            //  默认连接线样式
            style: {
                stroke: '#1890ff',
                lineWidth: 1,
                endArrow: { //  结束箭头
                    type: 'triangle',
                    fill: '#1890ff',
                    stroke: '#1890ff',
                    lineWidth: 1,
                },
            },
        },
        behaviors: (prev) => [...prev, 'hover-activate-chain'], //  鼠标悬浮
    };

    const updateCollapseExpandBehavior = (options) => {
        return (transforms) => [
            ...transforms.filter((transform) => (transform).key !== 'collapse-expand-react-node'),
            {
                ...(transforms.find((transform) => (transform).key === 'collapse-expand-react-node') || ({})),
                ...options,
            },
        ];
    };

    return data.nodes ? (
        <OrganizationChart {...options} transforms={updateCollapseExpandBehavior({
            enable: true,
            iconRender: (isCollapsed) => <PlusMinusIcon isCollapsed={isCollapsed} />,
            iconOffsetX: 0,
        })} />
    ) : ''
}
export default OrgStructureGraph;